import { Fragment, useEffect, useState } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Link from 'next/link';

import { BlogCardProps } from 'src/types';
import { fetchAllTrendingList } from '@lib/API';
import BlogPostCard from '@components/blog-posts/blog-post-card';
import ItemsTray from '@components/items-tray';
import { BrowserType } from '@constants/common';
import { PlatformType } from '@invideoio/web-shared/constants/common';

interface NoResultFoundPropTypes {
  platform: PlatformType;
  browser: BrowserType;
}
const NoResultFound = ({
  platform: devicePlatform,
  browser,
}: NoResultFoundPropTypes) => {
  const [trendingPosts, setTrendingPosts] = useState<BlogCardProps[]>([]);

  useEffect(() => {
    async function fetchTrendingPostsList() {
      const trendingPosts = await fetchAllTrendingList({ start: 0, limit: 3 });
      setTrendingPosts(trendingPosts);
    }
    fetchTrendingPostsList();
  }, []);

  return (
    <Fragment>
      <div
        className={ivclass(
          'iv-mx-[120px] md:iv-mx-40 sm:iv-mx-[0] ',
          'iv-mb-[70px]',
        )}
      >
        <div
          className={ivclass(
            'iv-text-heading-2xl iv-font-extrabold',
            'md:iv-text-heading-xl sm:iv-text-heading-xs',
            'iv-mb-25',
          )}
        >
          Sorry, no results found 😕
        </div>
        <div
          className={ivclass(
            'iv-text-heading-2xs iv-font-semibold',
            'md:iv-text-heading-3xs sm:iv-text-body-2xl ',
            'iv-text-black-50',
          )}
        >
          Try{' '}
          <Link href={`/blog/search/?q=${'Video editing tips'}`}>
            <a className={ivclass('iv-text-blue', 'hover:iv-cursor-pointer')}>
              {'‘Video editing tips’ '}
            </a>
          </Link>
          or take a look at trending posts:
        </div>
      </div>
      <div
        className={ivclass(
          'iv-container iv-mx-auto',
          'iv-overflow-hidden',
          'lg:iv-px-80',
        )}
      >
        {Array.isArray(trendingPosts) && trendingPosts.length > 0 && (
          <ItemsTray
            platform={devicePlatform}
            sliderWrapperCls={ivclass(
              'lg:iv-mr-20',
              'md:iv-mr-20',
              'sm:iv-mr-20',
            )}
          >
            {trendingPosts.map(post => (
              <div
                key={post.id}
                className={ivclass('iv-relative', ' iv-mr-40')}
              >
                <BlogPostCard
                  {...post}
                  devicePlatform={devicePlatform}
                  browser={browser}
                  backgroundColorClass={'iv-bg-black-4'}
                />
              </div>
            ))}
          </ItemsTray>
        )}
      </div>
    </Fragment>
  );
};

export default NoResultFound;
